// components/process-units/FieldCompression.js
import React, { useState } from 'react';

const FieldCompression = ({ config, updateConfig }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  // Handle input changes
  const handleInputChange = (field, value) => {
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      updateConfig({
        [field]: numValue
      });
    }
  };

  return (
    <div className="process-unit-card">
      <div 
        className="unit-header" 
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3>Field Compression</h3>
        <span className={`expand-icon ${isExpanded ? 'expanded' : ''}`}>
          {isExpanded ? '▼' : '▶'}
        </span>
      </div>
      
      {isExpanded && (
        <div className="unit-content">
          <p className="unit-description">
            Field compression increases the pressure of the gas from the wellhead to 
            facilitate transportation to the processing plant. The energy consumption 
            depends on the pressure ratio, gas composition, and compressor efficiency.
          </p>
          
          <div className="parameter-group">
            <div className="parameter-row">
              <label>Discharge Pressure (bar)</label>
              <input
                type="number"
                min="0"
                step="1"
                value={config.dischargePresure}
                onChange={(e) => handleInputChange('dischargePresure', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Compressor Efficiency (%)</label>
              <input
                type="number"
                min="0"
                max="100"
                step="1"
                value={config.efficiency * 100}
                onChange={(e) => handleInputChange('efficiency', e.target.value / 100)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Compressor Type</label>
              <select 
                value={config.compressorType || 'centrifugal'}
                onChange={(e) => updateConfig({ compressorType: e.target.value })}
              >
                <option value="centrifugal">Centrifugal</option>
                <option value="reciprocating">Reciprocating</option>
                <option value="screw">Screw</option>
              </select>
            </div>
            
            <div className="parameter-row">
              <label>Driver Type</label>
              <select 
                value={config.driverType || 'electricMotor'}
                onChange={(e) => updateConfig({ driverType: e.target.value })}
              >
                <option value="electricMotor">Electric Motor</option>
                <option value="gasTurbine">Gas Turbine</option>
                <option value="gasEngine">Gas Engine</option>
              </select>
            </div>
            
            <div className="parameter-row">
              <label>Number of Stages</label>
              <input
                type="number"
                min="1"
                max="5"
                step="1"
                value={config.stageCount || 1}
                onChange={(e) => handleInputChange('stageCount', e.target.value)}
              />
            </div>
            
            <div className="parameter-row">
              <label>Intercooler Temperature (°C)</label>
              <input
                type="number"
                min="0"
                max="100"
                step="1"
                value={config.intercoolerTemp || 40}
                onChange={(e) => handleInputChange('intercoolerTemp', e.target.value)}
              />
            </div>
          </div>
          
          <div className="unit-info-box">
            <h4>Engineering Notes</h4>
            <ul>
              <li>Centrifugal compressors are typically used for higher flow rates and moderate compression ratios.</li>
              <li>Reciprocating compressors provide higher compression ratios but at lower flow rates.</li>
              <li>Multiple compression stages with intercooling reduce power consumption by approaching isothermal compression.</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default FieldCompression;